module.exports = __webpack_public_path__ + "img/organ_m.3e3637f4.webp";